<template>
<div class="chapter">
<div class="inner_page">
<h1 class="tp">Sharon Sala</h1>
<h1 class="tp1">Suspense Stories</h1>
<p class="tp"><em>Butterfly<br/>Bloodlines<br/>Mimosa Grove</em><br/><br/></p>
<p class="tp1"><img alt="" src="OEBPS/images/logo.png"/><br/>New York, 2018</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// maintp.vue?32e251d0